module.exports = "images/transport_boat.14e433a03c6b3eb0a4ddc2733dff7f3f.png";